import { render, staticRenderFns } from "./ModalRevisaoCirurgica.vue?vue&type=template&id=385d3dde&scoped=true"
import script from "./ModalRevisaoCirurgica.vue?vue&type=script&lang=ts"
export * from "./ModalRevisaoCirurgica.vue?vue&type=script&lang=ts"
import style0 from "./ModalRevisaoCirurgica.vue?vue&type=style&index=0&id=385d3dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d3dde",
  null
  
)

export default component.exports